/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { HttpResponse, Logger } from '@app/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { Website } from '@app/settings/websites/website.model';
import { Model } from '@app/shared/models/model.model';

const log = new Logger('WebsitesService');

@Injectable({
  providedIn: 'root',
})
export class WebsitesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    log.debug('index');
    return this.http.get('v1/websites', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((website: any) => {
          return new Website().deserialize(website);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(website: Website): Observable<Website> {
    return this.http.put('v1/websites/' + website.id, website).pipe(
      map((response: HttpResponse) => {
        return new Website().deserialize(response.data);
      })
    );
  }

  store(website: Website): Observable<Website> {
    return this.http.post('v1/websites', website).pipe(
      map((response: HttpResponse) => {
        return new Website().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/websites/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Website().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/websites/' + id);
  }

  getLocales(query: ApiQuery = new ApiQuery()): Observable<any> {
    log.debug('getLocales');
    return this.http.get('v1/websites/locales', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return response.data;
      })
    );
  }
}
